import React from 'react'
import { useDispatch } from 'react-redux';

function Group({group}) {
    const dispatch = useDispatch();
    const selectGroup = ()=>{
        dispatch({type : "SELECT_GROUP" , payload : {group}})
    }

    return (
        <div className = "group-list-item"
        onClick = {selectGroup}>
            <h3 
            className = "group-name">
            {group.name}</h3>
        </div>
        )
}
export default Group
